import { Modal, Text } from '@shopify/polaris';

const UnsavedChangesModal = ({ open, onClose, onConfirm }) => {
    return (
        <Modal
            open={open}
            onClose={onClose}
            title={'Unsaved changes'}
            primaryAction={{
                content: 'Continue without saving',
                onAction: onConfirm,
                destructive: true,
            }}
            secondaryActions={[{ content: 'Go back', onAction: onClose }]}
        >
            <Modal.Section>
                <Text as="p" variant="bodySm" tone="subdued" style={{ marginTop: 12 }}>
                    You have unsaved changes that will be lost if you leave this page. Are you sure you want to continue?
                </Text>
            </Modal.Section>
        </Modal>
    );
};

export default UnsavedChangesModal;
